import React from 'react';
import { AssetUrls } from 'config/assets';
import './ProgressHeader.css';

interface ProgressHeaderProps {
  completedTasks: number;
  totalTasks: number;
  pointsEarned: number;
  totalPointsAvailable: number;
  isLoading?: boolean;
}

const ProgressHeader: React.FC<ProgressHeaderProps> = ({
  completedTasks,
  totalTasks,
  pointsEarned,
  totalPointsAvailable,
  isLoading = false,
}) => {
  const progressPercentage = totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0;

  return (
    <div className="progress-header">
      <div className="progress-header-content">
        <div className="progress-header-title">
          <h2>Earn Trade Credits by finishing setup</h2>
          <p>Earn another {totalPointsAvailable - pointsEarned} points by completing onboarding</p>
        </div>

        <div className="progress-header-stats">
          <div className="progress-stat">
            <span className="progress-stat-value">
              {isLoading ? '--' : completedTasks}/{isLoading ? '--' : totalTasks}
            </span>
            <span className="progress-stat-label">tasks completed</span>
          </div>
          <div className="progress-stat">
            <div className="progress-points-display">
              <img
                src={`${AssetUrls.base}/assets/icons/profile/coin.svg`}
                width={20}
                height={20}
                alt="points"
              />
              <span className="progress-points-value">
                {isLoading ? '--' : pointsEarned.toLocaleString()}/{isLoading ? '--' : totalPointsAvailable.toLocaleString()}
              </span>
            </div>
            <span className="progress-stat-label">points earned</span>
          </div>
        </div>
      </div>

      <div className="progress-bar-container">
        <div
          className={`progress-bar-fill ${isLoading ? 'loading' : ''}`}
          style={{ width: isLoading ? '0%' : `${progressPercentage}%` }}
          role="progressbar"
          aria-valuenow={progressPercentage}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={`${completedTasks} of ${totalTasks} tasks completed`}
        />
      </div>
    </div>
  );
};

export default ProgressHeader;
